import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@node-space/hooks'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getChatbotAuthToken } from 'services/ChatBotService'
import { QueryMetaType } from 'types/reactQuery'
import { setChatbotTokenCookie } from 'utils/utils'

export const useChatBotQuery = (isEnabled = false) => {
  const { isAuthed } = useAuth()

  const meta: QueryMetaType = {
    isErrorFatal: false,
  }

  return useQuery({
    queryKey: reactQueryKeys.chatbotToken(),
    queryFn: ({ signal }) => getChatbotAuthToken({ signal }),
    enabled: isEnabled && isAuthed,
    select: data => {
      setChatbotTokenCookie(data?.token)
      return data?.token
    },
    meta,
  })
}
